// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container-section {
  display: flex;
  padding: 12px 16px 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  /* margin: 0 auto 70px auto; */
  margin: 0 auto;
  width: 100%;
}

.profile-headder-section {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.user-profile-wrapper-box {
  /* width: 400px; */
  border-radius: 7px;
  background-color: #fff;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  gap: 10px;
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  /* flex: 1; */
  border: 1px solid #e6e6e6;
  padding: 0.75rem;
}

@media (max-width: 576px) {
  .user-profile-wrapper-box {
    flex-direction: column;
  }
}

.dark .user-profile-wrapper-box {
  background-color: #353a50;
  border: 1px solid #353a50;
}

.image-container-box {
  /* width: 100%;
  height: 100px; */
  /* margin: 5px; */
  /* border-radius: 7px; */
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  /* display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--surface-g0); */

  display: flex;
  height: 180px;
  width: 210px;
  padding: 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 8px;
  background: var(--Gray-50, #fafafb);
}

.dark .image-container-box {
  background-color: #5e5f69;
}

.organization-details-container {
  /* display: flex;
  align-items: flex-start;
  gap: 100px;
  flex: 1 0 0; */

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
}

.profile-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 3.2rem !important;
  padding: 1rem;
  gap: 1rem;
}

.user-profile-image-box {
  height: 80%;
  width: 100%;
  border-radius: 7px;
  object-fit: contain;
}

.profile-image-headder {
  display: flex;
  width: 96px;
  height: 96px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 16px;
  object-fit: contain;
}

.profile-image-style {
  height: 70%;
  width: 70%;
  border-radius: 50%;
  border: 3px solid gray;
}

.info-user-wrapper-box {
  display: grid;
  grid-template-columns: 1fr;
  /* grid-template-rows: 1fr 1fr; */
  width: 100%;
}

.info-flex-wrapper-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 5px 0;
}

.pos-text {
  white-space: nowrap;
  margin-bottom: 0.5rem;
}

@media (max-width: 576px) {
  .info-flex-wrapper-box {
    flex-direction: column;
  }
}

.org-text {
  font-size: 0.9em;
  font-weight: 500;
  color: var(--surface-g5);
}

.dark .org-text {
  color: #fff;
}

.org-id-text {
  font-size: 0.9em;
  font-weight: 700;
  color: var(--surface-g5);
}

.dark .org-id-text {
  color: #fff;
}

.basic-profile-wrapper-box {
  border-radius: 7px;
  height: 300px;
  background-color: #fff;
}

.user-basic-info-wrapper-box {
  border-radius: 7px;
  width: 100%;
  background-color: #fff;
  padding: 5px;
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  /* flex: 1; */
  border: 1px solid #e6e6e6;
}

.dark .user-basic-info-wrapper-box {
  background-color: #353a50;
  border: 1px solid #353a50;
}

.top-bar-basic-box {
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px;
  margin-top: 7px;
}

.user-basic-details-box {
  /* height: 300px; */
  /* margin-top: 10px; */
  display: flex;
}

.user-tag-wrapper-box {
  width: 40%;
  padding: 10px;
  line-height: 3.3;
}

.user-tag-wrapper-box-I {
  width: 60%;
  line-height: 3.3;
  padding: 5px;
}

.user-tag-wrapper-box-II {
  width: 60%;
  line-height: 3.1;
  margin-top: -5px;
  padding: 5px;
}

.name-text-wrapper-text {
  font-size: 0.9em;
  font-weight: 500;
  color: rgb(50, 47, 47);
}

.save-wrapper-box {
  display: flex;
  align-items: center;
  gap: 5px;
}

.user-input-wrapper-input {
  width: 100%;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 8px;
}

.user-input-wrapper-input:focus {
  outline: none;
}

.edit-text {
  cursor: pointer;
  color: #2954a5;
  font-weight: 600;
  font-size: 0.9em;
}

.edit-text-icon-1 {
  cursor: pointer;
  font-size: 0.9em;
  /* height: 1.5rem !important; */
  background-color: transparent !important;
  color: var(--blue) !important;
}

.org-text-I {
  color: var(--surface-g5);
  font-weight: 700;
  font-size: 0.9em;
  margin-left: 5px;
}

.dark .org-text-I {
  color: #fff;
}

.dark .name-text-wrapper-text {
  color: #fff;
}

.org-text-II {
  color: #000;
  font-weight: 600;
  font-size: 0.9em;
  margin-left: 5px;
}

.dark .org-text-II {
  color: #fff;
}

.delete-inner-wrapper-box {
  padding: 5px;
}

.delete-account-wrapper-box {
  width: 400px;
  border-radius: 7px;
  background-color: var(--surface-g0);
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  padding: 0.2rem;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.dark .delete-account-wrapper-box {
  background-color: #353a50;
  border: 1px solid #353a50;
}

.dark .delete-inner-wrapper-box {
  padding: 0px;
}

.light-delete-text {
  font-size: 0.8em;
  font-weight: 500;
  color: gray;
  margin-left: 5px;
  margin-top: 5px;
}

.dark .light-delete-text {
  color: #fff;
}

.delete-wrapper-button-box {
  width: 50%;
  float: right;
  padding: 0.5rem;
  text-align: center;
  border-radius: 5px;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 1rem;
}

@media (max-width: 576px) {
  .delete-wrapper-button-box {
    width: 100%;
  }
}

.logout-wrapper-btn {
  font-weight: 600 !important;
  color: #fff !important;
  border-radius: 5px;
  margin-left: 5px !important;
  background-color: #2954a5 !important;
}

.change-pin-wrapper-box {
  padding: 5px;
  border-bottom: 5px;
}

.change-pin-wrapper-box > div {
  justify-content: space-between;
}

.pin-wrapper-input {
  border: none;
  border-bottom: 1px solid lightgray;
  width: 250px;
  padding: 5px;
  margin-top: 5px;
}

.pin-wrapper-input:focus {
  outline: none;
}

.save-wrapper-box {
  float: right;
  margin-top: 5px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.save-wrapper-btn {
  width: 70px !important;
  background-color: #2954a5 !important;
  color: #fff !important;
  font-weight: 600 !important;
  font-size: 0.7em !important;
}

.pin-wrapper-modal-box {
  /* border: none;
  border-radius: 20px !important; */
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
}

.pin-wrapper-modal-box:focus {
  outline: none;
}

.old-pin-text {
  /* font-size: 1rem !important;
  font-weight: 600;
  color: var(--surface-g5); */
  font-size: 0.875rem;
  /* text-sm */
  font-weight: 600;
  /* font-semibold */
  color: #0f172a;
}

.old-pin-text:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.dark .user-input-wrapper-input {
  background-color: #353a50;
  color: #fff !important;
}

.otp_input_box {
  font-size: 20px;
  height: 40px;
  border-radius: 10px;
  width: 35px !important;
  border: none;
  padding: 5px !important;
  box-shadow:
    rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}

.change-pin-otp-input {
  font-size: 1.25rem;
  border-radius: 8px;
  width: 100%;
  padding: 6px 8px;
  border: 1px solid var(--surface-g2);
  color: #333;
  background-color: #fff;
  transition:
    border-color 0.3s ease,
    outline-color 0.3s ease;
  margin: 8px 0;
}

.change-pin-otp-input:focus {
  border-color: #007bff;
  outline: 1px solid #007bff;
}

.profile-change-pin-par {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.user-data-input-par {
  padding: 1rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.personal-details-input-par {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.user-input-label-settings {
  font-size: 1rem !important;

  color: var(--Gray-500, #717681);

  /* Text xs/Regular */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.dark .user-input-label-settings {
  color: var(--surface-g1) !important;
}

/* Styles for the InputLabel */
.dark .user-input-label-settings .MuiInputLabel-root {
  color: #fff !important;
  /* For the label text */
}

/* Styles for the Input value (normal state) */
.dark .MuiInputBase-input {
  /* Applies to both Input and TextField's inner input */
  color: #fff !important;
  /* Your desired white color for dark mode */
}

/* Styles for the Input value (disabled state) */
.dark .MuiInputBase-input.Mui-disabled {
  color: #fff !important;
  /* White color for disabled state in dark mode */
  /* Crucial for Webkit browsers (Chrome, Safari, Edge) */
  -webkit-text-fill-color: #fff !important;
}

/* If you are using Input specifically, you might also target: */
.dark .MuiInput-input.Mui-disabled {
  color: #fff !important;
  -webkit-text-fill-color: #fff !important;
}

/* To ensure the bottom border for 'standard' variant also changes color in dark mode */
.dark .MuiInput-underline:before {
  border-bottom-color: rgba(255, 255, 255, 0.7) !important;
  /* Lighter border for dark mode */
}

.dark .MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom-color: #fff !important;
  /* White hover border */
}

.dark .MuiInput-underline:after {
  border-bottom-color: #fff !important;
  /* White focused border */
}

/* For TextField's standard variant (which uses MuiInput-underline internally) */
.dark .MuiTextField-root .MuiInput-underline:before {
  border-bottom-color: rgba(255, 255, 255, 0.7) !important;
}

.dark .MuiTextField-root .MuiInput-underline:hover:not(.Mui-disabled):before {
  border-bottom-color: #fff !important;
}

.dark .MuiTextField-root .MuiInput-underline:after {
  border-bottom-color: #fff !important;
}

/* If using Filled variant, adjust its background and border */
.dark .MuiFilledInput-root {
  background-color: rgba(255, 255, 255, 0.1) !important;
  /* Dark mode filled background */
}

.dark .MuiFilledInput-root:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
}

.dark .MuiFilledInput-root.Mui-focused {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.dark .MuiFilledInput-underline:after {
  border-bottom-color: #fff !important;
  /* White focused border for filled */
}

/* If using Outlined variant, adjust its border */
.dark .MuiOutlinedInput-notchedOutline {
  border-color: rgba(255, 255, 255, 0.7) !important;
  /* Dark mode outlined border */
}

.dark .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #fff !important;
  /* White hover border for outlined */
}

.dark .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #fff !important;
  /* White focused border for outlined */
}

.containerWrapperSection {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;

  border-radius: 12px;
  border: 1px solid var(--Blue-100, #bfeaff);
  background: var(--White, #fff);
}

.containerSection {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}

.dark .containerWrapperSection {
  background-color: #353a50;
  border: 1px solid #353a50;
}

.containerWrapper-headder-div {
  display: flex;
  padding: 0 0 12px 0;
  flex-direction: column;
  align-items: center;
  gap: 427.306px;
  align-self: stretch;
  border-bottom: 1px solid var(--Blue-100, #bfeaff);
}

.containerWrapper-content-div {
  display: flex;
  height: 24px;
  padding-right: 0;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.containerWrapper-left-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.containerWrapper-icon {
  display: flex;
}

.containerWrapper-right-content {
  display: flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 16px;
  background: var(--Gray-200, #e9eaec);
}

.containerWrapper-right-content-p {
  color: var(--Gray-700, #414652);
  text-align: center;

  /* Text xs/Medium */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.dark .containerWrapper-left-content-p {
  color: #fff;
}

.containerWrapper-left-content-p {
  color: var(--Gray-800, #252b36);

  /* Text md/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.profile-headder-section {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  flex: 1;
}

.profile-header-section-left-div {
  display: flex;
  flex-direction: row;

  align-items: center;
  gap: 10px;
  flex: 1 0 0;
}

.profile-header-section-right-div {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.profile-header-section-profile {
  color: var(--Gray-800, #252b36);

  /* Text md/Bold */
  font-family: "Outfit", "Inter", sans-serif;

  font-style: normal;

  line-height: normal;
  font-size: 20px;
  line-height: 28px;

  font-weight: 800;

  color: #111827;
}

.dark .profile-header-section-profile {
  color: #f4f5f6;
}

.profile-header-section-sub-profile {
  color: #6b7280;

  /* Text sm/Regular */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.dark .profile-header-section-sub-profile {
  color: #90a1b9;
}

.profile-body-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.containerHeadderIconImages {
  color: red;
}

.notification-preference-section {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.notification-preference-left-div {
  display: flex;
  width: 300px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.notification-preference-right-div {
  display: flex;
  width: 300px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.toggle-container-div {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.toggleButton-label {
  /* Text sm/Medium */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.organization-name-container-section {
  display: flex;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
}

.orgdetails-left-section-data {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 26px;
}

.orgdetails-left-div-data-row {
  display: flex;
  /* width: 300px; */
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.edit-section-p {
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.edit-btn-gap-padding {
  display: flex !important;
  gap: 8px !important;
  padding: 8px;
}

.save-edit-btn-component {
  display: flex;
  padding-top: 8px;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
}

.edit-text-btn {
  display: flex;
  padding: var(--8, 8px);
  align-items: center;
  gap: var(--8, 8px);
}

.cancel-btn-style {
  display: flex;
  padding: var(--8, 8px);
  align-items: center;
  gap: var(--8, 8px);
  height: auto !important;
}

.save-btn-style {
  display: flex;
  padding: var(--8, 8px);
  align-items: center;
  gap: var(--8, 8px);
  height: auto !important;
}

.personal-details-parent-section {
  display: flex;
  align-items: center;
  gap: 24px;
  align-self: stretch;
}

.orgDetails-p-label {
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.orgDetails-p-value {
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.personal-details-row-1-section {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.personal-info-container-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  /* flex: 1 0 0; */
  align-self: stretch;
  overflow: hidden;
  border-radius: 32px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: linear-gradient(
    135deg,
    rgba(15, 23, 42, 0.98),
    rgba(37, 99, 235, 0.94),
    rgba(14, 165, 233, 0.84)
  );
  padding: 32px;
  color: white;
  box-shadow: 0 28px 90px rgba(15, 23, 42, 0.18);
}

.personal-info-details-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 14px;
  flex: 1 0 0;
  align-self: stretch;
}

.personal-details-cards {
  border-radius: 22px;

  border: 1px solid rgba(255, 255, 255, 0.15);

  background-color: rgba(255, 255, 255, 0.1);

  padding-left: 20px;
  padding-right: 20px;
  padding-top: 16px;
  padding-bottom: 16px;
  flex: 1;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.personal-details-cards .personal-details-cards-header {
  font-size: 10px;

  font-weight: 700;

  text-transform: uppercase;

  letter-spacing: 0.16em;

  color: rgba(255, 255, 255, 0.55);
}

.personal-details-cards .personal-details-cards-value {
  font-size: 12px;
  color: #ffffffa6;
  font-weight: 500;
  margin-bottom: 10px;
}

.personal-details-cards .personal-details-cards-description {
  margin-top: 4px;

  font-size: 14px;
  line-height: 20px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  color: rgba(255, 255, 255, 0.7);
}

.personal-details-cards-container {
  display: flex;
  width: 60%;
  gap: 10px;
}

.personal-details-div-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
}

.personal-details-h2-tag {
  align-self: stretch;
  /* Text lg/Bold */
  font-family: "Outfit", "Inter", sans-serif;
  margin-top: 8px;
  font-size: 30px;
  font-style: normal;
  line-height: 36px;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.badge-group {
  display: flex;
  gap: 10px;
}

.badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background-color: rgba(255, 255, 255, 0.1);
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
}

.avatar-wrapper {
  position: relative;
  margin-right: 25px;
}

.avatar {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 96px;
  width: 96px;

  border-radius: 9999px;
  border: 4px solid rgba(255, 255, 255, 0.7);
  background-color: rgba(255, 255, 255, 0.12);

  font-size: 30px;
  font-weight: 700;

  overflow: hidden;

  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.avatar img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.status-dot {
  position: absolute;
  bottom: 4px;
  right: 4px;

  height: 20px;
  width: 20px;

  border-radius: 9999px;

  border: 4px solid rgb(255, 255, 255);
  background-color: rgb(52, 211, 153);
}

.icon {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

.badge-active {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid rgba(110, 231, 183, 0.2);
  background-color: rgba(52, 211, 153, 0.15);
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  color: rgb(209, 250, 229);
}

.personal-details-roles-tab {
  align-self: stretch;

  color: var(--Gray-500, #717681);
  /* Text sm/Regular */
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.form-user-personal-details {
  border-radius: 24px;
  border: 1px solid rgba(0, 0, 0, 0.6);
  background-color: rgba(255, 255, 255, 0.6);
  padding: 20px;
}

.personal-details-sub-tab {
  font-family: "Outfit", "Inter", sans-serif;
  font-size: 11px;
  text-transform: uppercase;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: var(--Gray-500, rgba(255, 255, 255, 0.6));
  letter-spacing: 0.2em;
}

.dark .personal-details-sub-tab {
  color: #b4b9c4;
}

.roles-badge-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.role-badge {
  padding: 2px 6px;
  border-radius: 6px;
  background-color: #edf8ff;
  color: #0860e6;
  font-size: 13px;
  font-weight: 500;
}

/* ProfileSection.css */

/* Container */
.profile-section {
  border-radius: 30px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  padding: 24px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  transition: all 0.3s ease;
  height: auto;
  min-height: auto;
  margin-bottom: 20px;
}

/* Header */
.profile-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding-bottom: 20px;
}

.profile-section-title {
  font-size: 11px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.16em;
}

.profile-section-title.info {
  color: #3b82f6;
}

.profile-section-title.status {
  color: #8b5cf6;
}

.profile-section-title.security {
  color: #10b981;
}

.profile-section-title.quick-actions {
  color: #94a3b8;
}

.profile-section-heading {
  margin-top: 8px;
  font-size: 24px;
  font-weight: bold;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 12px;
}

.subtitle-icon-span {
  display: flex;
  align-items: center;
  justify-content: center;

  height: 44px;
  width: 44px;
  border-radius: 50%;
  background-color: #f1f5f9;
}
/*
.subtitle-icon-svg {
  width: 24px;
  height: 24px;
}

.profile-section-title.notifications {
  color: #7008e9;
} */

.profile-section-subtitle {
  margin-top: 8px;
  font-size: 14px;
  line-height: 24px;
  color: #64748b;
}

.profile-section-description {
  margin-top: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #64748b;
  font-weight: 400;
}

div.status-dot {
  height: 20px;
  width: 20px;
  background-color: green;
}

/* Edit Button */
.edit-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 36px;
}

.edit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.edit-button:active {
  transform: translateY(0);
  box-shadow: none;
}

/* Badge */
.profile-badge {
  border-radius: 9999px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 900;
}

.profile-badge.default {
  background-color: #f1f5f9;
  color: #334155;
}

.profile-badge.violet {
  background-color: #ede9fe;
  color: #7008e9;
}

.profile-badge.emerald {
  background-color: #d1fae5;
  color: #065f46;
}

/* Grid Layout */
.info-grid {
  margin-top: 24px;
  display: grid;
  gap: 16px;
}

@media (min-width: 768px) {
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Info Card */
.info-card {
  border-radius: 24px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background-color: #fafbfc;
  padding: 20px;
}

.info-card-content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.info-icon {
  display: flex;
  height: 44px;
  width: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background-color: #f1f5f9;
  color: #64748b;
}

.info-label {
  font-size: 14px;
  color: #64748b;
}

.info-value {
  font-weight: 600;
  color: #0f172a;
}

/* Status Items */
.status-list {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.status-card {
  border-radius: 24px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background-color: #fafbfc;
  padding: 20px;
}

.status-card-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.status-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}

.status-description {
  margin-top: 4px;
  font-size: 14px;
  line-height: 24px;
  color: #64748b;
}

.status-enabled,
.status-on {
  background-color: #d1fae5;
  color: #065f46;
  border-radius: 10px;
  display: inline-block;
  border-radius: 9999px;
  padding: 4px 12px;
  /* py-1 px-3 */
  font-size: 12px;
  /* text-xs */
  font-weight: 900;
  /* font-semibold */

  background-color: #d1fae5;
  color: #047857;
}

.status-muted,
.status-off {
  background-color: #e2e8f0;
  color: #334155;
  border-radius: 10px;
  display: inline-block;
  border-radius: 9999px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 900;
}

.button-profile-back {
  display: flex;
  height: 36px;
  width: 36px;

  align-items: center;
  justify-content: center;

  border-radius: 9999px;

  background-color: #f1f5f9;

  transition: background-color 0.2s ease;
  border: none;
  cursor: pointer;
}

/* Quick Actions */
.quick-actions-list {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.profile-section-header .edit-button {
  border: solid 1px black;
}

.quick-action-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 24px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background-color: #fafbfc;
  padding: 16px;
}

.quick-action-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.quick-action-icon {
  display: flex;
  height: 44px;
  width: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background-color: #f1f5f9;
  color: #64748b;
}

.quick-action-title {
  font-weight: 600;
  color: #0f172a;
}

.quick-action-description {
  font-size: 14px;
  color: #64748b;
}

.chevron-button {
  border-radius: 9999px;
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: #64748b;
  transition: all 0.2s ease;
}

.chevron-button:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

/* SVG Icons */
.icon {
  width: 20px;
  height: 20px;
}

/* container */
.layout-grid {
  margin-top: 24px;
  /* mt-6 */
  display: grid;
  gap: 24px;
  /* gap-6 */
  align-items: start;
  width: 100%;
  margin-bottom: 70px;
}

/* default (mobile / small screens) */
.layout-grid {
  grid-template-columns: 1fr;
}

.layout-grid .profile-section {
  width: 100%;
}

p.status-description,
p.quick-action-description {
  margin-top: 4px;
  font-size: 14px;
  line-height: 24px;
  color: #64748b;
}

p.quick-action-title,
p.status-title {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
}

@media (min-width: 1280px) {
  .layout-grid {
    grid-template-columns: 1.2fr 0.85fr;
  }

  .account-page-content {
    grid-template-columns: 1fr !important;
  }

  .profile-container-section {
    width: 90%;
  }

  .profile-badge {
    width: 18%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .profile-badge.emerald {
    width: 58%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

/* Notifications Container */
.notifications-container {
  margin-top: 1.25rem;
}

.notification-summary {
  margin-bottom: 1rem;
}

.notification-summary-text {
  font-size: 0.875rem;
  color: var(--muted-foreground);
}

.notifications-grid {
  display: grid;
  gap: 0.5rem 2.5rem;
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 768px) {
  .notifications-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.notification-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  border-radius: 20px;
  padding: 0.5rem 0.25rem;
}

.notification-label {
  font-size: 15px;
  font-weight: 500;
  color: var(--card-foreground);
}

/* Switch Styles */
.notification-switch {
  display: inline-flex;
  height: 1.25rem;
  width: 2.25rem;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  border-radius: 9999px;
  border: 2px solid transparent;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.notification-switch:focus-visible {
  outline: none;
  ring: 2px solid var(--ring);
  ring-offset: 2px;
}

.notification-switch.switch-checked {
  background-color: var(--primary);
}

.notification-switch.switch-unchecked {
  background-color: var(--input);
}

.notification-switch.switch-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.notification-switch-thumb {
  pointer-events: none;
  display: block;
  height: 1rem;
  width: 1rem;
  border-radius: 9999px;
  background-color: var(--background);
  box-shadow:
    0 0 0 2px rgba(0, 0, 0, 0.05),
    0 0 0 2px var(--ring);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.notification-switch-thumb.thumb-checked {
  transform: translateX(1rem);
}

.notification-switch-thumb.thumb-unchecked {
  transform: translateX(0);
}

/* Custom details card small variant */
.personal-details-cards-small {
  padding: 12px 16px !important;
}

.personal-details-cards-small .personal-details-cards-header {
  font-size: 9px !important;
}

.personal-details-cards-small .personal-details-cards-value {
  font-size: 15px !important;
  line-height: 20px !important;
  margin-top: 4px !important;
}

.personal-details-cards-small .personal-details-cards-value.value-margin-bottom {
  margin-bottom: 8px !important;
}

/* Notification Preferences Not Allowed cursors */
.notifications-container {
  cursor: not-allowed;
}

.notification-row {
  cursor: not-allowed;
}

.notification-label {
  cursor: not-allowed;
}

.notification-row .switch {
  pointer-events: none;
}

/* Assigned Roles Layout adjustments */
.assigned-roles-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.assigned-roles-header-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.assigned-roles-subheader {
  margin-top: 4px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.7);
}

.profile-role-count-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background-color: rgba(255, 255, 255, 0.1);
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  white-space: nowrap;
}

.assigned-roles-chips-container {
  margin-top: 16px;
  display: flex;
  max-height: 132px;
  flex-wrap: wrap;
  gap: 8px;
  overflow-y: auto;
  padding-right: 4px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/Account/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,SAAS;EACT,iDAAiD;EACjD,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE;kBACgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,iDAAiD;EACjD;;;wCAGsC;;EAEtC,aAAa;EACb,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;;;gBAGc;;EAEd,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,iDAAiD;EACjD,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,iDAAiD;EACjD,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE;mCACiC;EACjC,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;6BAE2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB;;0CAEwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mCAAmC;EACnC,WAAW;EACX,sBAAsB;EACtB;;2BAEyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;;EAE1B,+BAA+B;;EAE/B,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,sDAAsD;EACtD,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA,gDAAgD;AAChD;EACE,sBAAsB;EACtB,gDAAgD;EAChD,uDAAuD;EACvD,wCAAwC;AAC1C;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,uFAAuF;AACvF;EACE,wDAAwD;EACxD,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,gFAAgF;AAChF;EACE,wDAAwD;AAC1D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,8DAA8D;AAC9D;EACE,qDAAqD;EACrD,gCAAgC;AAClC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,iDAAiD;AACjD;EACE,iDAAiD;EACjD,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;;EAEnB,mBAAmB;EACnB,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;;EAElB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;;EAE/B,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,+BAA+B;;EAE/B,iBAAiB;EACjB,0CAA0C;;EAE1C,kBAAkB;;EAElB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;;EAEjB,gBAAgB;;EAEhB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;;EAEd,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C;;;;;GAKC;EACD,aAAa;EACb,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;;EAEnB,2CAA2C;;EAE3C,0CAA0C;;EAE1C,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,OAAO;EACP,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,eAAe;;EAEf,gBAAgB;;EAEhB,yBAAyB;;EAEzB,sBAAsB;;EAEtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;;EAEf,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;EACZ,WAAW;;EAEX,qBAAqB;EACrB,0CAA0C;EAC1C,2CAA2C;;EAE3C,eAAe;EACf,gBAAgB;;EAEhB,gBAAgB;;EAEhB,0CAA0C;EAC1C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;;EAEV,YAAY;EACZ,WAAW;;EAEX,qBAAqB;;EAErB,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;;EAEnB,+BAA+B;EAC/B,oBAAoB;EACpB,0CAA0C;EAC1C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,uBAAuB;;AAEvB,cAAc;AACd;EACE,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;EACb,8CAA8C;EAC9C,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;;;;;;;GAQG;;AAEH;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;;EAElB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;;EAEX,mBAAmB;EACnB,uBAAuB;;EAEvB,qBAAqB;;EAErB,yBAAyB;;EAEzB,sCAAsC;EACtC,YAAY;EACZ,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;AACd;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,+FAA+F;EAC/F,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,mCAAmC;EACnC;;yBAEuB;EACvB,8BAA8B;EAC9B,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;EAC3C,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".profile-container-section {\n  display: flex;\n  padding: 12px 16px 8px 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n  align-self: stretch;\n  /* margin: 0 auto 70px auto; */\n  margin: 0 auto;\n  width: 100%;\n}\n\n.profile-headder-section {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.user-profile-wrapper-box {\n  /* width: 400px; */\n  border-radius: 7px;\n  background-color: #fff;\n  display: flex;\n  /* flex-direction: column; */\n  align-items: center;\n  gap: 10px;\n  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */\n  /* flex: 1; */\n  border: 1px solid #e6e6e6;\n  padding: 0.75rem;\n}\n\n@media (max-width: 576px) {\n  .user-profile-wrapper-box {\n    flex-direction: column;\n  }\n}\n\n.dark .user-profile-wrapper-box {\n  background-color: #353a50;\n  border: 1px solid #353a50;\n}\n\n.image-container-box {\n  /* width: 100%;\n  height: 100px; */\n  /* margin: 5px; */\n  /* border-radius: 7px; */\n  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */\n  /* display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--surface-g0); */\n\n  display: flex;\n  height: 180px;\n  width: 210px;\n  padding: 12px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  border-radius: 8px;\n  background: var(--Gray-50, #fafafb);\n}\n\n.dark .image-container-box {\n  background-color: #5e5f69;\n}\n\n.organization-details-container {\n  /* display: flex;\n  align-items: flex-start;\n  gap: 100px;\n  flex: 1 0 0; */\n\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n  width: 100%;\n}\n\n.profile-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 3.2rem !important;\n  padding: 1rem;\n  gap: 1rem;\n}\n\n.user-profile-image-box {\n  height: 80%;\n  width: 100%;\n  border-radius: 7px;\n  object-fit: contain;\n}\n\n.profile-image-headder {\n  display: flex;\n  width: 96px;\n  height: 96px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  border-radius: 16px;\n  object-fit: contain;\n}\n\n.profile-image-style {\n  height: 70%;\n  width: 70%;\n  border-radius: 50%;\n  border: 3px solid gray;\n}\n\n.info-user-wrapper-box {\n  display: grid;\n  grid-template-columns: 1fr;\n  /* grid-template-rows: 1fr 1fr; */\n  width: 100%;\n}\n\n.info-flex-wrapper-box {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 5px 0;\n}\n\n.pos-text {\n  white-space: nowrap;\n  margin-bottom: 0.5rem;\n}\n\n@media (max-width: 576px) {\n  .info-flex-wrapper-box {\n    flex-direction: column;\n  }\n}\n\n.org-text {\n  font-size: 0.9em;\n  font-weight: 500;\n  color: var(--surface-g5);\n}\n\n.dark .org-text {\n  color: #fff;\n}\n\n.org-id-text {\n  font-size: 0.9em;\n  font-weight: 700;\n  color: var(--surface-g5);\n}\n\n.dark .org-id-text {\n  color: #fff;\n}\n\n.basic-profile-wrapper-box {\n  border-radius: 7px;\n  height: 300px;\n  background-color: #fff;\n}\n\n.user-basic-info-wrapper-box {\n  border-radius: 7px;\n  width: 100%;\n  background-color: #fff;\n  padding: 5px;\n  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */\n  /* flex: 1; */\n  border: 1px solid #e6e6e6;\n}\n\n.dark .user-basic-info-wrapper-box {\n  background-color: #353a50;\n  border: 1px solid #353a50;\n}\n\n.top-bar-basic-box {\n  height: 58px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px;\n  margin-top: 7px;\n}\n\n.user-basic-details-box {\n  /* height: 300px; */\n  /* margin-top: 10px; */\n  display: flex;\n}\n\n.user-tag-wrapper-box {\n  width: 40%;\n  padding: 10px;\n  line-height: 3.3;\n}\n\n.user-tag-wrapper-box-I {\n  width: 60%;\n  line-height: 3.3;\n  padding: 5px;\n}\n\n.user-tag-wrapper-box-II {\n  width: 60%;\n  line-height: 3.1;\n  margin-top: -5px;\n  padding: 5px;\n}\n\n.name-text-wrapper-text {\n  font-size: 0.9em;\n  font-weight: 500;\n  color: rgb(50, 47, 47);\n}\n\n.save-wrapper-box {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.user-input-wrapper-input {\n  width: 100%;\n  border: 1px solid lightgray;\n  border-radius: 5px;\n  padding: 8px;\n}\n\n.user-input-wrapper-input:focus {\n  outline: none;\n}\n\n.edit-text {\n  cursor: pointer;\n  color: #2954a5;\n  font-weight: 600;\n  font-size: 0.9em;\n}\n\n.edit-text-icon-1 {\n  cursor: pointer;\n  font-size: 0.9em;\n  /* height: 1.5rem !important; */\n  background-color: transparent !important;\n  color: var(--blue) !important;\n}\n\n.org-text-I {\n  color: var(--surface-g5);\n  font-weight: 700;\n  font-size: 0.9em;\n  margin-left: 5px;\n}\n\n.dark .org-text-I {\n  color: #fff;\n}\n\n.dark .name-text-wrapper-text {\n  color: #fff;\n}\n\n.org-text-II {\n  color: #000;\n  font-weight: 600;\n  font-size: 0.9em;\n  margin-left: 5px;\n}\n\n.dark .org-text-II {\n  color: #fff;\n}\n\n.delete-inner-wrapper-box {\n  padding: 5px;\n}\n\n.delete-account-wrapper-box {\n  width: 400px;\n  border-radius: 7px;\n  background-color: var(--surface-g0);\n  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */\n  padding: 0.2rem;\n  border: 1px solid #e6e6e6;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.dark .delete-account-wrapper-box {\n  background-color: #353a50;\n  border: 1px solid #353a50;\n}\n\n.dark .delete-inner-wrapper-box {\n  padding: 0px;\n}\n\n.light-delete-text {\n  font-size: 0.8em;\n  font-weight: 500;\n  color: gray;\n  margin-left: 5px;\n  margin-top: 5px;\n}\n\n.dark .light-delete-text {\n  color: #fff;\n}\n\n.delete-wrapper-button-box {\n  width: 50%;\n  float: right;\n  padding: 0.5rem;\n  text-align: center;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  gap: 1rem;\n}\n\n@media (max-width: 576px) {\n  .delete-wrapper-button-box {\n    width: 100%;\n  }\n}\n\n.logout-wrapper-btn {\n  font-weight: 600 !important;\n  color: #fff !important;\n  border-radius: 5px;\n  margin-left: 5px !important;\n  background-color: #2954a5 !important;\n}\n\n.change-pin-wrapper-box {\n  padding: 5px;\n  border-bottom: 5px;\n}\n\n.change-pin-wrapper-box > div {\n  justify-content: space-between;\n}\n\n.pin-wrapper-input {\n  border: none;\n  border-bottom: 1px solid lightgray;\n  width: 250px;\n  padding: 5px;\n  margin-top: 5px;\n}\n\n.pin-wrapper-input:focus {\n  outline: none;\n}\n\n.save-wrapper-box {\n  float: right;\n  margin-top: 5px;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.save-wrapper-btn {\n  width: 70px !important;\n  background-color: #2954a5 !important;\n  color: #fff !important;\n  font-weight: 600 !important;\n  font-size: 0.7em !important;\n}\n\n.pin-wrapper-modal-box {\n  /* border: none;\n  border-radius: 20px !important; */\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1300;\n}\n\n.pin-wrapper-modal-box:focus {\n  outline: none;\n}\n\n.old-pin-text {\n  /* font-size: 1rem !important;\n  font-weight: 600;\n  color: var(--surface-g5); */\n  font-size: 0.875rem;\n  /* text-sm */\n  font-weight: 600;\n  /* font-semibold */\n  color: #0f172a;\n}\n\n.old-pin-text:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.dark .user-input-wrapper-input {\n  background-color: #353a50;\n  color: #fff !important;\n}\n\n.otp_input_box {\n  font-size: 20px;\n  height: 40px;\n  border-radius: 10px;\n  width: 35px !important;\n  border: none;\n  padding: 5px !important;\n  box-shadow:\n    rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\n    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;\n}\n\n.change-pin-otp-input {\n  font-size: 1.25rem;\n  border-radius: 8px;\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid var(--surface-g2);\n  color: #333;\n  background-color: #fff;\n  transition:\n    border-color 0.3s ease,\n    outline-color 0.3s ease;\n  margin: 8px 0;\n}\n\n.change-pin-otp-input:focus {\n  border-color: #007bff;\n  outline: 1px solid #007bff;\n}\n\n.profile-change-pin-par {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.user-data-input-par {\n  padding: 1rem;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.personal-details-input-par {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.user-input-label-settings {\n  font-size: 1rem !important;\n\n  color: var(--Gray-500, #717681);\n\n  /* Text xs/Regular */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.dark .user-input-label-settings {\n  color: var(--surface-g1) !important;\n}\n\n/* Styles for the InputLabel */\n.dark .user-input-label-settings .MuiInputLabel-root {\n  color: #fff !important;\n  /* For the label text */\n}\n\n/* Styles for the Input value (normal state) */\n.dark .MuiInputBase-input {\n  /* Applies to both Input and TextField's inner input */\n  color: #fff !important;\n  /* Your desired white color for dark mode */\n}\n\n/* Styles for the Input value (disabled state) */\n.dark .MuiInputBase-input.Mui-disabled {\n  color: #fff !important;\n  /* White color for disabled state in dark mode */\n  /* Crucial for Webkit browsers (Chrome, Safari, Edge) */\n  -webkit-text-fill-color: #fff !important;\n}\n\n/* If you are using Input specifically, you might also target: */\n.dark .MuiInput-input.Mui-disabled {\n  color: #fff !important;\n  -webkit-text-fill-color: #fff !important;\n}\n\n/* To ensure the bottom border for 'standard' variant also changes color in dark mode */\n.dark .MuiInput-underline:before {\n  border-bottom-color: rgba(255, 255, 255, 0.7) !important;\n  /* Lighter border for dark mode */\n}\n\n.dark .MuiInput-underline:hover:not(.Mui-disabled):before {\n  border-bottom-color: #fff !important;\n  /* White hover border */\n}\n\n.dark .MuiInput-underline:after {\n  border-bottom-color: #fff !important;\n  /* White focused border */\n}\n\n/* For TextField's standard variant (which uses MuiInput-underline internally) */\n.dark .MuiTextField-root .MuiInput-underline:before {\n  border-bottom-color: rgba(255, 255, 255, 0.7) !important;\n}\n\n.dark .MuiTextField-root .MuiInput-underline:hover:not(.Mui-disabled):before {\n  border-bottom-color: #fff !important;\n}\n\n.dark .MuiTextField-root .MuiInput-underline:after {\n  border-bottom-color: #fff !important;\n}\n\n/* If using Filled variant, adjust its background and border */\n.dark .MuiFilledInput-root {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  /* Dark mode filled background */\n}\n\n.dark .MuiFilledInput-root:hover {\n  background-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n.dark .MuiFilledInput-root.Mui-focused {\n  background-color: rgba(255, 255, 255, 0.2) !important;\n}\n\n.dark .MuiFilledInput-underline:after {\n  border-bottom-color: #fff !important;\n  /* White focused border for filled */\n}\n\n/* If using Outlined variant, adjust its border */\n.dark .MuiOutlinedInput-notchedOutline {\n  border-color: rgba(255, 255, 255, 0.7) !important;\n  /* Dark mode outlined border */\n}\n\n.dark .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #fff !important;\n  /* White hover border for outlined */\n}\n\n.dark .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #fff !important;\n  /* White focused border for outlined */\n}\n\n.containerWrapperSection {\n  display: flex;\n  padding: 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  align-self: stretch;\n\n  border-radius: 12px;\n  border: 1px solid var(--Blue-100, #bfeaff);\n  background: var(--White, #fff);\n}\n\n.containerSection {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  align-self: stretch;\n}\n\n.dark .containerWrapperSection {\n  background-color: #353a50;\n  border: 1px solid #353a50;\n}\n\n.containerWrapper-headder-div {\n  display: flex;\n  padding: 0 0 12px 0;\n  flex-direction: column;\n  align-items: center;\n  gap: 427.306px;\n  align-self: stretch;\n  border-bottom: 1px solid var(--Blue-100, #bfeaff);\n}\n\n.containerWrapper-content-div {\n  display: flex;\n  height: 24px;\n  padding-right: 0;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n}\n\n.containerWrapper-left-content {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.containerWrapper-icon {\n  display: flex;\n}\n\n.containerWrapper-right-content {\n  display: flex;\n  padding: 2px 6px;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  border-radius: 16px;\n  background: var(--Gray-200, #e9eaec);\n}\n\n.containerWrapper-right-content-p {\n  color: var(--Gray-700, #414652);\n  text-align: center;\n\n  /* Text xs/Medium */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.dark .containerWrapper-left-content-p {\n  color: #fff;\n}\n\n.containerWrapper-left-content-p {\n  color: var(--Gray-800, #252b36);\n\n  /* Text md/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.profile-headder-section {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  flex: 1;\n}\n\n.profile-header-section-left-div {\n  display: flex;\n  flex-direction: row;\n\n  align-items: center;\n  gap: 10px;\n  flex: 1 0 0;\n}\n\n.profile-header-section-right-div {\n  display: flex;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.profile-header-section-profile {\n  color: var(--Gray-800, #252b36);\n\n  /* Text md/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n\n  font-style: normal;\n\n  line-height: normal;\n  font-size: 20px;\n  line-height: 28px;\n\n  font-weight: 800;\n\n  color: #111827;\n}\n\n.dark .profile-header-section-profile {\n  color: #f4f5f6;\n}\n\n.profile-header-section-sub-profile {\n  color: #6b7280;\n\n  /* Text sm/Regular */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n\n.dark .profile-header-section-sub-profile {\n  color: #90a1b9;\n}\n\n.profile-body-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n}\n\n.containerHeadderIconImages {\n  color: red;\n}\n\n.notification-preference-section {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n}\n\n.notification-preference-left-div {\n  display: flex;\n  width: 300px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.notification-preference-right-div {\n  display: flex;\n  width: 300px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.toggle-container-div {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.toggleButton-label {\n  /* Text sm/Medium */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.organization-name-container-section {\n  display: flex;\n  align-items: flex-start;\n  gap: 32px;\n  align-self: stretch;\n}\n\n.orgdetails-left-section-data {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 26px;\n}\n\n.orgdetails-left-div-data-row {\n  display: flex;\n  /* width: 300px; */\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n}\n\n.edit-section-p {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.edit-btn-gap-padding {\n  display: flex !important;\n  gap: 8px !important;\n  padding: 8px;\n}\n\n.save-edit-btn-component {\n  display: flex;\n  padding-top: 8px;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 24px;\n}\n\n.edit-text-btn {\n  display: flex;\n  padding: var(--8, 8px);\n  align-items: center;\n  gap: var(--8, 8px);\n}\n\n.cancel-btn-style {\n  display: flex;\n  padding: var(--8, 8px);\n  align-items: center;\n  gap: var(--8, 8px);\n  height: auto !important;\n}\n\n.save-btn-style {\n  display: flex;\n  padding: var(--8, 8px);\n  align-items: center;\n  gap: var(--8, 8px);\n  height: auto !important;\n}\n\n.personal-details-parent-section {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  align-self: stretch;\n}\n\n.orgDetails-p-label {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.orgDetails-p-value {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.personal-details-row-1-section {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.personal-info-container-section {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 24px;\n  /* flex: 1 0 0; */\n  align-self: stretch;\n  overflow: hidden;\n  border-radius: 32px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background: linear-gradient(\n    135deg,\n    rgba(15, 23, 42, 0.98),\n    rgba(37, 99, 235, 0.94),\n    rgba(14, 165, 233, 0.84)\n  );\n  padding: 32px;\n  color: white;\n  box-shadow: 0 28px 90px rgba(15, 23, 42, 0.18);\n}\n\n.personal-info-details-div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 14px;\n  flex: 1 0 0;\n  align-self: stretch;\n}\n\n.personal-details-cards {\n  border-radius: 22px;\n\n  border: 1px solid rgba(255, 255, 255, 0.15);\n\n  background-color: rgba(255, 255, 255, 0.1);\n\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  flex: 1;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.personal-details-cards .personal-details-cards-header {\n  font-size: 10px;\n\n  font-weight: 700;\n\n  text-transform: uppercase;\n\n  letter-spacing: 0.16em;\n\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.personal-details-cards .personal-details-cards-value {\n  font-size: 12px;\n  color: #ffffffa6;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.personal-details-cards .personal-details-cards-description {\n  margin-top: 4px;\n\n  font-size: 14px;\n  line-height: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  row-gap: 8px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.personal-details-cards-container {\n  display: flex;\n  width: 60%;\n  gap: 10px;\n}\n\n.personal-details-div-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 6px;\n  align-self: stretch;\n}\n\n.personal-details-h2-tag {\n  align-self: stretch;\n  /* Text lg/Bold */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  margin-top: 8px;\n  font-size: 30px;\n  font-style: normal;\n  line-height: 36px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n}\n\n.badge-group {\n  display: flex;\n  gap: 10px;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.avatar-wrapper {\n  position: relative;\n  margin-right: 25px;\n}\n\n.avatar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 96px;\n  width: 96px;\n\n  border-radius: 9999px;\n  border: 4px solid rgba(255, 255, 255, 0.7);\n  background-color: rgba(255, 255, 255, 0.12);\n\n  font-size: 30px;\n  font-weight: 700;\n\n  overflow: hidden;\n\n  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.avatar img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n.status-dot {\n  position: absolute;\n  bottom: 4px;\n  right: 4px;\n\n  height: 20px;\n  width: 20px;\n\n  border-radius: 9999px;\n\n  border: 4px solid rgb(255, 255, 255);\n  background-color: rgb(52, 211, 153);\n}\n\n.icon {\n  width: 12px;\n  height: 12px;\n  margin-right: 4px;\n}\n\n.badge-active {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid rgba(110, 231, 183, 0.2);\n  background-color: rgba(52, 211, 153, 0.15);\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: rgb(209, 250, 229);\n}\n\n.personal-details-roles-tab {\n  align-self: stretch;\n\n  color: var(--Gray-500, #717681);\n  /* Text sm/Regular */\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.form-user-personal-details {\n  border-radius: 24px;\n  border: 1px solid rgba(0, 0, 0, 0.6);\n  background-color: rgba(255, 255, 255, 0.6);\n  padding: 20px;\n}\n\n.personal-details-sub-tab {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  font-size: 11px;\n  text-transform: uppercase;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  color: var(--Gray-500, rgba(255, 255, 255, 0.6));\n  letter-spacing: 0.2em;\n}\n\n.dark .personal-details-sub-tab {\n  color: #b4b9c4;\n}\n\n.roles-badge-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.role-badge {\n  padding: 2px 6px;\n  border-radius: 6px;\n  background-color: #edf8ff;\n  color: #0860e6;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* ProfileSection.css */\n\n/* Container */\n.profile-section {\n  border-radius: 30px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  background-color: #ffffff;\n  padding: 24px;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n  transition: all 0.3s ease;\n  height: auto;\n  min-height: auto;\n  margin-bottom: 20px;\n}\n\n/* Header */\n.profile-section-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n  padding-bottom: 20px;\n}\n\n.profile-section-title {\n  font-size: 11px;\n  font-weight: bold;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n}\n\n.profile-section-title.info {\n  color: #3b82f6;\n}\n\n.profile-section-title.status {\n  color: #8b5cf6;\n}\n\n.profile-section-title.security {\n  color: #10b981;\n}\n\n.profile-section-title.quick-actions {\n  color: #94a3b8;\n}\n\n.profile-section-heading {\n  margin-top: 8px;\n  font-size: 24px;\n  font-weight: bold;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.subtitle-icon-span {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  height: 44px;\n  width: 44px;\n  border-radius: 50%;\n  background-color: #f1f5f9;\n}\n/*\n.subtitle-icon-svg {\n  width: 24px;\n  height: 24px;\n}\n\n.profile-section-title.notifications {\n  color: #7008e9;\n} */\n\n.profile-section-subtitle {\n  margin-top: 8px;\n  font-size: 14px;\n  line-height: 24px;\n  color: #64748b;\n}\n\n.profile-section-description {\n  margin-top: 8px;\n  font-size: 14px;\n  line-height: 20px;\n  color: #64748b;\n  font-weight: 400;\n}\n\ndiv.status-dot {\n  height: 20px;\n  width: 20px;\n  background-color: green;\n}\n\n/* Edit Button */\n.edit-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 8px 16px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background-color: transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-height: 36px;\n}\n\n.edit-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.edit-button:active {\n  transform: translateY(0);\n  box-shadow: none;\n}\n\n/* Badge */\n.profile-badge {\n  border-radius: 9999px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 900;\n}\n\n.profile-badge.default {\n  background-color: #f1f5f9;\n  color: #334155;\n}\n\n.profile-badge.violet {\n  background-color: #ede9fe;\n  color: #7008e9;\n}\n\n.profile-badge.emerald {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n/* Grid Layout */\n.info-grid {\n  margin-top: 24px;\n  display: grid;\n  gap: 16px;\n}\n\n@media (min-width: 768px) {\n  .info-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Info Card */\n.info-card {\n  border-radius: 24px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  background-color: #fafbfc;\n  padding: 20px;\n}\n\n.info-card-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.info-icon {\n  display: flex;\n  height: 44px;\n  width: 44px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background-color: #f1f5f9;\n  color: #64748b;\n}\n\n.info-label {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.info-value {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n/* Status Items */\n.status-list {\n  margin-top: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.status-card {\n  border-radius: 24px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  background-color: #fafbfc;\n  padding: 20px;\n}\n\n.status-card-content {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.status-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.status-description {\n  margin-top: 4px;\n  font-size: 14px;\n  line-height: 24px;\n  color: #64748b;\n}\n\n.status-enabled,\n.status-on {\n  background-color: #d1fae5;\n  color: #065f46;\n  border-radius: 10px;\n  display: inline-block;\n  border-radius: 9999px;\n  padding: 4px 12px;\n  /* py-1 px-3 */\n  font-size: 12px;\n  /* text-xs */\n  font-weight: 900;\n  /* font-semibold */\n\n  background-color: #d1fae5;\n  color: #047857;\n}\n\n.status-muted,\n.status-off {\n  background-color: #e2e8f0;\n  color: #334155;\n  border-radius: 10px;\n  display: inline-block;\n  border-radius: 9999px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 900;\n}\n\n.button-profile-back {\n  display: flex;\n  height: 36px;\n  width: 36px;\n\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 9999px;\n\n  background-color: #f1f5f9;\n\n  transition: background-color 0.2s ease;\n  border: none;\n  cursor: pointer;\n}\n\n/* Quick Actions */\n.quick-actions-list {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.profile-section-header .edit-button {\n  border: solid 1px black;\n}\n\n.quick-action-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border-radius: 24px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  background-color: #fafbfc;\n  padding: 16px;\n}\n\n.quick-action-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.quick-action-icon {\n  display: flex;\n  height: 44px;\n  width: 44px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 16px;\n  background-color: #f1f5f9;\n  color: #64748b;\n}\n\n.quick-action-title {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.quick-action-description {\n  font-size: 14px;\n  color: #64748b;\n}\n\n.chevron-button {\n  border-radius: 9999px;\n  padding: 8px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #64748b;\n  transition: all 0.2s ease;\n}\n\n.chevron-button:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n}\n\n/* SVG Icons */\n.icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* container */\n.layout-grid {\n  margin-top: 24px;\n  /* mt-6 */\n  display: grid;\n  gap: 24px;\n  /* gap-6 */\n  align-items: start;\n  width: 100%;\n  margin-bottom: 70px;\n}\n\n/* default (mobile / small screens) */\n.layout-grid {\n  grid-template-columns: 1fr;\n}\n\n.layout-grid .profile-section {\n  width: 100%;\n}\n\np.status-description,\np.quick-action-description {\n  margin-top: 4px;\n  font-size: 14px;\n  line-height: 24px;\n  color: #64748b;\n}\n\np.quick-action-title,\np.status-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n@media (min-width: 1280px) {\n  .layout-grid {\n    grid-template-columns: 1.2fr 0.85fr;\n  }\n\n  .account-page-content {\n    grid-template-columns: 1fr !important;\n  }\n\n  .profile-container-section {\n    width: 90%;\n  }\n\n  .profile-badge {\n    width: 18%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .profile-badge.emerald {\n    width: 58%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n/* Notifications Container */\n.notifications-container {\n  margin-top: 1.25rem;\n}\n\n.notification-summary {\n  margin-bottom: 1rem;\n}\n\n.notification-summary-text {\n  font-size: 0.875rem;\n  color: var(--muted-foreground);\n}\n\n.notifications-grid {\n  display: grid;\n  gap: 0.5rem 2.5rem;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n@media (min-width: 768px) {\n  .notifications-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.notification-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  border-radius: 20px;\n  padding: 0.5rem 0.25rem;\n}\n\n.notification-label {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--card-foreground);\n}\n\n/* Switch Styles */\n.notification-switch {\n  display: inline-flex;\n  height: 1.25rem;\n  width: 2.25rem;\n  flex-shrink: 0;\n  cursor: pointer;\n  align-items: center;\n  border-radius: 9999px;\n  border: 2px solid transparent;\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.notification-switch:focus-visible {\n  outline: none;\n  ring: 2px solid var(--ring);\n  ring-offset: 2px;\n}\n\n.notification-switch.switch-checked {\n  background-color: var(--primary);\n}\n\n.notification-switch.switch-unchecked {\n  background-color: var(--input);\n}\n\n.notification-switch.switch-disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.notification-switch-thumb {\n  pointer-events: none;\n  display: block;\n  height: 1rem;\n  width: 1rem;\n  border-radius: 9999px;\n  background-color: var(--background);\n  box-shadow:\n    0 0 0 2px rgba(0, 0, 0, 0.05),\n    0 0 0 2px var(--ring);\n  transition-property: transform;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.notification-switch-thumb.thumb-checked {\n  transform: translateX(1rem);\n}\n\n.notification-switch-thumb.thumb-unchecked {\n  transform: translateX(0);\n}\n\n/* Custom details card small variant */\n.personal-details-cards-small {\n  padding: 12px 16px !important;\n}\n\n.personal-details-cards-small .personal-details-cards-header {\n  font-size: 9px !important;\n}\n\n.personal-details-cards-small .personal-details-cards-value {\n  font-size: 15px !important;\n  line-height: 20px !important;\n  margin-top: 4px !important;\n}\n\n.personal-details-cards-small .personal-details-cards-value.value-margin-bottom {\n  margin-bottom: 8px !important;\n}\n\n/* Notification Preferences Not Allowed cursors */\n.notifications-container {\n  cursor: not-allowed;\n}\n\n.notification-row {\n  cursor: not-allowed;\n}\n\n.notification-label {\n  cursor: not-allowed;\n}\n\n.notification-row .switch {\n  pointer-events: none;\n}\n\n/* Assigned Roles Layout adjustments */\n.assigned-roles-card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.assigned-roles-header-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  width: 100%;\n}\n\n.assigned-roles-subheader {\n  margin-top: 4px;\n  font-size: 14px;\n  line-height: 20px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.profile-role-count-badge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background-color: rgba(255, 255, 255, 0.1);\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.85);\n  white-space: nowrap;\n}\n\n.assigned-roles-chips-container {\n  margin-top: 16px;\n  display: flex;\n  max-height: 132px;\n  flex-wrap: wrap;\n  gap: 8px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
